import { render, staticRenderFns } from "./StockItemListGroups.vue?vue&type=template&id=4da25e3e&scoped=true&"
import script from "./StockItemListGroups.vue?vue&type=script&lang=js&"
export * from "./StockItemListGroups.vue?vue&type=script&lang=js&"
import style0 from "./StockItemListGroups.vue?vue&type=style&index=0&id=4da25e3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da25e3e",
  null
  
)

export default component.exports